import { Service } from '../store/service/Service';
import { getService } from '../store/service/selectors';
import { AppState } from '../store/AppState';
import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {GoToProfileAction} from '../+edit/store';

@Component({
  selector: 'girko-header-connected',
  template: `
    <girko-header
      [service]="service$|async"
      (goToProfile)="goToProfile($event)"
      (hamburgerClick)="hamburgerClick.emit()"
    ></girko-header>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderConnectedComponent {
  @Output() hamburgerClick = new EventEmitter<any>();
  service$: Observable<Service> = this.store$.select(getService);

  constructor(private store$: Store<AppState>) {}

  goToProfile(service: Service) {
    this.store$.dispatch(new GoToProfileAction(service));
  }
}
